import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";
import CircularProgress from "@mui/material/CircularProgress";

// Dreamer Admin Panel Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import curved9 from "assets/images/curved-images/sign-in.png";
import api from "api/api";
import { ApiResponse } from "model/apiResponseModel";

function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("loginData") || sessionStorage.getItem("loginData"));
    if (loginData) {
        navigate('/dashboard');
    }
  }, []);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    try {
      const data = { email, password };
      const response = await api.login(data);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        const { token, email, profile_picture, name, userId } = response.data;
        
        const loginData = {
          isLoggedIn: true,
          timestamp: rememberMe ? null : Date.now(),
          token,
          email,
          profile_picture,
          name,
          userId,
        };

        if (rememberMe) {
           localStorage.setItem("loginData", JSON.stringify(loginData));
        } else {
           sessionStorage.setItem("loginData", JSON.stringify(loginData));
        }

        window.location.href = "/dashboard";
      } else {
        alert("Invalid email or password.");
      }
    } catch (error) {
      console.error("Login failed", error);
      alert("An error occurred while trying to log in.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <CoverLayout
      title="Welcome back"
      description="Enter your email and password to sign in"
      image={curved9}
    >
      <SoftBox component="form" role="form" onSubmit={handleSignIn}>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Email
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Password
            </SoftTypography>
          </SoftBox>
          <SoftInput
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </SoftBox>
        <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton type="submit" variant="gradient" color="info" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : "Sign In"}
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default SignIn;
